import { ERROR_VALIDATION_FAILED } from '@/constants/commons';
import { ResponseErrorType } from '@/types/api';

export const getErrorMessage = (error?: ResponseErrorType, isShowFieldInMessage = false) => {
  if (!error) return '';
  const { data } = error;
  let message = data?.message ?? error?.message;

  switch (data?.id) {
    case ERROR_VALIDATION_FAILED:
      if (data.errors?.length)
        message = `${isShowFieldInMessage ? `${data.errors[0].field} ` : ''}${
          data.errors[0].message
        }`;
      break;
    default:
      break;
  }

  return message;
};
